import { render, staticRenderFns } from "./ReportsHsqeDefects.vue?vue&type=template&id=2268ff52&"
import script from "./ReportsHsqeDefects.vue?vue&type=script&lang=js&"
export * from "./ReportsHsqeDefects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports